import { canv } from '@/canv/global.js'

export class shapeInternalStorage {

    constructor() {

    }

    drawRoundedRect(x, y, w, h, r) {
        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;
        canv.ctx.beginPath();
        canv.ctx.moveTo(x+r, y);
        canv.ctx.arcTo(x+w, y,   x+w, y+h, r);
        canv.ctx.arcTo(x+w, y+h, x,   y+h, r);
        canv.ctx.arcTo(x,   y+h, x,   y,   r);
        canv.ctx.arcTo(x,   y,   x+w, y,   r);
        canv.ctx.closePath();
    }

    fitText(textPart, x, y, width, height, verticalPadding, horizontalPadding) {

        var gap = height / 16;
        gap = width / 16 < gap ? gap : width / 16;

        var allowedWidth = width - gap - 2 * horizontalPadding;
        var allowedHeight = height - gap - 2 * verticalPadding;


        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + gap + (width - gap) / 2 - textPart.width / 2;
        textPart.startY = y + gap + textPart.lines[0].textHeight + (height - gap) / 2 - textPart.height / 2;

        textPart.updateDims();

        return {
            "allowedWidth": allowedWidth,
            "allowedHeight": allowedHeight
        };
    }

    draw(x, y, width, height) {

        this.drawRoundedRect(x, y, width, height, height / 30);

        var gap = height / 16;
        gap = width / 16 < gap ? gap : width / 16;

        canv.ctx.moveTo(x + gap, y);
        canv.ctx.lineTo(x + gap, y + height);

        canv.ctx.moveTo(x, y + gap);
        canv.ctx.lineTo(x + width, y + gap);
    }

    getAvatar(color) {
        return `
        <svg width="115" height="80" viewBox="0 0 115 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="113.29" height="79" rx="9.5" fill="` + color + `" stroke="black"/>
        <line x1="11.5" x2="11.5" y2="79" stroke="black"/>
        <line x1="1" y1="10.5" x2="114" y2="10.5" stroke="black"/>
        </svg>
        `;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 25;
            height = 25;
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="` + width + `" height="` + height + `" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="24" height="16.4993" rx="1.5" fill="` + fill + `" stroke="black"/>
                <line x1="5.5" x2="5.5" y2="17.2806" stroke="black"/>
                <line y1="4.5" x2="24.7178" y2="4.5" stroke="black"/>
            </svg>
        `;
    }

}
